// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__H+1DX","jpCurrentDate":"JP_Footer_jpCurrentDate__lvwco","jpFootage":"JP_Footer_jpFootage__9LoHL","higlight":"JP_Footer_higlight__Z9ie2"};